import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ContactForm } from "@/components/support/ContactForm";
import { FAQ, faqs } from "@/components/support/FAQ";
import { SEO, buildBreadcrumbSchema, buildFAQSchema } from "@/components/seo/SEO";
import { Mail, MessageCircle, Clock } from "lucide-react";

const Support = () => {
  return (
    <div className="min-h-screen flex flex-col app-surface">
      <SEO
        title="Help & FAQ — Email2Contact for Outlook"
        description="Get help with Email2Contact: how the Outlook add-in works, supported platforms, credit system, GDPR & EU AI hosting, billing, and how to contact support."
        path="/support"
        jsonLd={[
          buildBreadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Support", path: "/support" },
          ]),
          buildFAQSchema(faqs),
        ]}
      />
      <Navbar />

      <main className="flex-grow py-16 md:py-20 bg-dot-grid">
        <div className="container px-4 max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-14 max-w-2xl mx-auto">
            <p className="text-xs font-mono uppercase tracking-[0.18em] text-muted-foreground mb-4">
              Help Center
            </p>
            <h1 className="font-display text-4xl md:text-5xl font-semibold mb-4 tracking-tight">
              How can we help you?
            </h1>
            <p className="text-lg text-muted-foreground">
              Find answers to common questions or get in touch with our support team.
            </p>
          </div>

          {/* Contact Cards */}
          <div className="grid md:grid-cols-3 gap-4 mb-16">
            <div className="app-tile app-tile-hover p-6 text-center">
              <div className="mx-auto app-icon-box mb-3">
                <Mail className="w-5 h-5" />
              </div>
              <h3 className="app-section-title mb-1">Contact form</h3>
              <p className="text-sm text-muted-foreground mb-3">Send us a message</p>
              <a href="#contact" className="text-sm text-primary hover:underline font-medium">
                Fill out the form →
              </a>
            </div>

            <div className="app-tile app-tile-hover p-6 text-center">
              <div className="mx-auto app-icon-box mb-3">
                <MessageCircle className="w-5 h-5" />
              </div>
              <h3 className="app-section-title mb-1">Live chat</h3>
              <p className="text-sm text-muted-foreground mb-3">Chat with our team</p>
              <span className="app-pill app-pill-neutral">Coming soon</span>
            </div>

            <div className="app-tile app-tile-hover p-6 text-center">
              <div className="mx-auto app-icon-box mb-3">
                <Clock className="w-5 h-5" />
              </div>
              <h3 className="app-section-title mb-1">Response time</h3>
              <p className="text-sm text-muted-foreground mb-3">We typically respond within</p>
              <p className="text-sm font-semibold">24 hours</p>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="mb-20">
            <div className="text-center mb-8">
              <h2 className="font-display text-3xl font-semibold mb-2 tracking-tight">
                Frequently asked questions
              </h2>
              <p className="text-muted-foreground">
                Find quick answers to the most common questions about Email2Contact.
              </p>
            </div>
            <div className="max-w-3xl mx-auto">
              <FAQ />
            </div>
          </div>

          {/* Contact Form Section */}
          <div id="contact" className="max-w-2xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="font-display text-3xl font-semibold mb-2 tracking-tight">
                Still have questions?
              </h2>
              <p className="text-muted-foreground">
                Send us a message and we'll get back to you as soon as possible.
              </p>
            </div>
            <ContactForm />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Support;
